import { MaterialTypes, Pathname } from '../constants/data'
import { generateBaseStaticWidthURL, STATIC_URL } from '../constants/data'

const max = 'maxresdefault.jpg'
const mqdefault = 'maxresdefault.jpg'

const generateTumbnail = (videoLink: string, customWidth?: string): string => {
  const size = customWidth ? max : mqdefault
  if (videoLink.includes('rutube')) {
    const regexRutube = /video(?:\/private)?\/([a-zA-Z0-9]{32})/
    const match = videoLink.match(regexRutube)
    const idPreview = match ? match[1] : 0
    return `https://rutube.ru/api/video/${idPreview}/thumbnail/?redirect=1`
  }

  return videoLink ? `https://img.youtube.com/vi/${videoLink}/${size}` : ''
}

const getPreviewFolder = (type: MaterialTypes | undefined): Pathname => {
  switch (type) {
    case MaterialTypes.WEBINAR:
      return Pathname.WEBINAR
    case MaterialTypes.FUTURE_WEBINAR:
      return Pathname.WEBINAR
    case MaterialTypes.PODCAST:
      return Pathname.PODCAST
    default:
      return Pathname.ARTICLE
  }
}

const generateStaticPreview = (
  url: string,
  previewName?: string,
  materialType?: MaterialTypes,
  customWidth?: string
) => {
  const typeName = getPreviewFolder(materialType)
  const width = Number(customWidth ? `${customWidth}` : '1000')
  return previewName
    ? `${url}${generateBaseStaticWidthURL(width)}/${typeName}/${previewName}`
    : `${url}${STATIC_URL}/cards/preview.png`
}

export { generateTumbnail, generateStaticPreview }
